




































import {Component} from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import {
    CreateOrgDepartment,
    GetOraganizationList,
    GetOrgDepartmentList,
    UpdateOrgDepartment
} from "@/api/organization"
import myTable from '../../../components/table/my-table.vue'
import myform from '../../../components/form/index.vue'
import {QuerySysDic} from "@/api/material"

@Component({
    components:{myTable,myform}
})
export default class Department extends AbpBase {
    formShow = false
    formTitle = ''
    data:any [] = []
    formItem:any [] = []
    formData:any = {}
    columns = [
        {
            title: '部门编号',
            key: 'code'
        },
        {
            title: '部门名称',
            key: 'name'
        },
        {
            title: '拼音',
            key: 'pinyin'
        },
        {
            title: '五笔',
            key: 'wubi'
        },
        {
            title: '隶属组织',
            key: 'organizationName'
        },
        {
            title: '类型',
            key: 'departmentTypeName'
        },
        {
            title: '备注',
            key: 'remarks'
        },
        {
            title: '操作',
            width: '100px',
            render:(h:any, p:any)=>{
                return h('el-button',{
                    props: {
                        type: 'text'
                    },
                    directives:[{
                        name:'allow'
                    }],
                    on: {
                        click: () => {
                            this.addOrEdit(p.row)
                        }
                    }
                },'编辑')
            }
        },
    ]
    created() {
        this.getData()
        this.getOptions()
    }

    organizationIds = []
    departIds = []
    async getOptions() {
        let res = await GetOraganizationList({id: -1})
        this.getTree(
            res,
            this.organizationIds,
            {
                value:'id',
                text:'organizationName',
            },
            'parentId',
            'value',
        )
        this.departIds = (await QuerySysDic({"dataType":8,"typeName":"","status":true})).data.map(item => {item.text = item.typeName;item.value = item.id;return item})
    }
    async addOrEdit(row:object){
        this.formTitle = !row?'新增':'编辑'
        this.formData = {
            code:'',
            name:'',
            pinyin:'',
            wubi:'',
            organizationId:null,
            departmentTypeId:'',
            remarks:'',
            isActive:true,
        }
        this.formData = Object.assign(this.formData,row)
        this.formItem = [
            {
                column:12,
                show:true,
                label:'部门编码',
                name:'code',
                type:'text',
                placeholder:'请输入部门编码',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ],
            },
            {
                column:12,
                show:true,
                label:'部门名称',
                name:'name',
                type:'text',
                placeholder:'请输入部门名称',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ],
                //发成change的回调,
                onchange:async (value)=>{
                    let obj = await this.GetPinYinAndWubi({inputStr:value})
                    let val = eval('(' + obj + ')')
                    this.formData['wubi'] = val.Wubi
                    this.formData['pinyin'] = val.PinYin
                }
            },
            {
                column:12,
                show:true,
                label:'拼音助记符',
                name:'pinyin',
                type:'text',
                placeholder:'请输入拼音助记符',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ]
            },
            {
                column:12,
                show:true,
                label:'五笔助记符',
                name:'wubi',
                type:'text',
                placeholder:'请输入五笔助记符',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ]
            },
            {
                column:12,
                show:true,
                label:'隶属组织',
                name:'organizationId',
                type:'selectTree',
                placeholder:'请选择隶属组织',
                options: this.organizationIds,
                props:{                // 配置项（必选）
                    value: 'value',
                    label: 'text',
                    children: 'children',
                },
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ]
            },
            {
                column:12,
                show:true,
                label:'部门类型',
                name:'departmentTypeId',
                type:'select',
                placeholder:'请选择部门类型',
                options: this.departIds,
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ]
            },
            {
                column:24,
                show:true,
                label:'备注',
                name:'remarks',
                type:'textarea',
            },
            {
                column:12,
                show:true,
                label:'是否激活',
                name:'isActive',
                type:'switch',
            }
        ]
        this.formShow = true
        console.log(this.formItem)
    }
    pageChange(page:number){
        this.table.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.table.pageSize = pagesize
        this.getData();
    }
    private async getData() {
        this.table.loading = true
        let res = await GetOrgDepartmentList({
            QueryString: this.table.queryString,
            Status: this.table.status,
            PageSize: this.table.pageSize,
            Page: this.table.page
        })
        this.data = res.items
        this.table.totalCount = res.totalCount
        this.table.loading = false
    }
    async submit(data:any){
        let res;
        if(data.id){
            res = await UpdateOrgDepartment(data)
        }else{
            res = await CreateOrgDepartment(data)
        }
        if(res.code ===2000){
            this.formShow = false
            this.getData()
        }
    }
}
